
<section class="breadcrumb-section">
    <div class="container">
        <div class="row">
            <div class="col-md-12">
                <div class="breadcrumb-title">
                    <h1>ROCS</h1>
                </div>
            </div>
        </div>			
    </div>
</section>      
    <ul class="breadcrumb">
        <li><a href="#">Placement</a></li>
        <li><i class="fa fa-angle-double-right"></i></li>
        <li>ROCS</li>
    </ul>

<section class="section-lg chair-msg">
    <div class="container">
        <div class="row justify-content-center">
            <div class="col-md-12">
                <div class="inner-title"  >
                    <h3>ROCS</h3>							
                   
                </div>
                <div class="text-justify" >
                    <p>The Raisoni Office of Career Services ( ROCS) is a unique new initiative undertaken for the first time among educational institutions in Central India, to TRANSFORM STUDENTS CAREER PATHWAY, like never before :</p>
                </div>
                <div class="inner-title"  >
                    <h5>Key Benefits envisaged for the students, include:</h5>							
                   
                </div> 
                <ul class="list-item">
                    <li>INTEGRATED Training, Placements, III Cell & Alumni activities in each campus</li>
                    <li>PERSONALIZED service to students</li>
                    <li>Career Pathway for each student WILL BE discussed</li>
                    <li>Student MENTOR is assigned in all colleges</li>
                    <li>DEVELOPMENT of INDIVIDUAL Student Development plan</li>
                    <li>ROCS – TRANSFORMING STUDENTS CAREER PATHWAY</li>
                </ul>
                <div class="text-justify mt-2">
                    <p>Preparing our young professionals for the next steps may involve self-discovery, exploration, and skill development, honing their interviewing skills, and developing a timeline for how they will achieve their goals. The 4 keys areas of ROCS are:</p>
                    <p><strong>Self-Discovery :</strong> Learning about who you are and how you want to make an impact is a great place to begin. Careers that combine your skills, interests, values, and personality are usually a great fit.</p>
                    <p><strong>Exploration :</strong> Exploring your personal, academic, and career interests enables you to begin to develop career goals. Reflecting on experiences in your classes, internships, student groups, and community will generate many interesting options to consider and learn more about.</p>
                    <p><strong>Preparation :</strong> Preparing for your next steps may involve developing relevant skills. But it will also involve putting together a strong resume, learning how to write a cover letter, developing graduate school or fellowship applications, understanding the importance of networking, honing your interviewing skills, and developing a timeline for how you’ll achieve your goals.</p>
                    <p><strong>Action :</strong> Once you have some ideas about next steps, you’re ready to move forward!</p>
                </div>
                <div class="inner-title"  >
                    <h5>Key Deliverables</h5>							
                   
                </div>
                <div class="row">
                    <div class="col-md-4">
                        <h6>New</h6>
                        <ul class="list-item">
                            <li>Industry Need Analysis</li>
                            <li>Competencies Employers Looking For </li>
                        </ul>
                    </div>
                    <div class="col-md-4">
                        <h6>Better</h6>
                        <ul class="list-item">
                            <li>CV Refinement, Mentoring, Aptitude</li>
                            <li>SAR Stories</li>
                        </ul>
                    </div>
                    <div class="col-md-4">
                        <h6>Different</h6>
                        <ul class="list-item">
                            <li>Individualized Student Development Plan</li>
                            <li>Integrated Approach - SEPA Concept</li>
                        </ul>
                    </div>
                </div>
                <div class="text-justify mt-2">
                    <p>The key differentiator envisaged in ROCS is an INDIVIDUALIZED STUDENT DEVELOPMENT PLAN, which recognizes the fact that every student is special and his or her development needs are different from many others. ROCS works to educate, connect, and advise students about opportunities for summer and post-graduation in order to foster their intellectual, social, and personal transformations.</p>
                </div>
            </div>
        </div>
    </div>
</section>

